import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Modal,
  TextField,
  Typography,
} from "@material-ui/core";
import { ModalStyles } from "../styles";
import { useFormik } from "formik";
import { Api } from "../lib/api";
import { useSnackbar } from "notistack";
import { cloneDeep } from "lodash";

type CreateNewSourceModalProps = {
  open: boolean;
  onClose: () => void;
  onSourceCreated: () => void;
  userSlug: string;
  websiteSlug?: string;
};

export const CreateNewSourceModal = ({
  open,
  onClose,
  userSlug,
  onSourceCreated,
  websiteSlug,
}: CreateNewSourceModalProps) => {
  const modalStyles = ModalStyles();

  const { enqueueSnackbar } = useSnackbar();

  const formik = useFormik({
    initialValues: {
      url: "",
      active: true,
    },
    onSubmit: async (data) => {
      const clonedData: any = cloneDeep(data);
      if (websiteSlug) clonedData.parentCanonicalSlug = websiteSlug;

      try {
        await Api.createSource(userSlug, clonedData);
        onSourceCreated();
      } catch (error: any) {
        enqueueSnackbar(error.response.data.message, { variant: "error" });
      }
      onClose();
    },
    enableReinitialize: true,
  });

  return (
    <Modal open={open} onClose={onClose}>
      <div className={modalStyles.paper}>
        <>
          <Box mb={4}>
            <Typography variant="h4" component="h4">
              Create new {websiteSlug ? "child" : null} Website{" "}
              {websiteSlug ? `for ${websiteSlug}` : null}
            </Typography>
          </Box>
          <form noValidate autoComplete="off" onSubmit={formik.handleSubmit}>
            <Box mb={2}>
              <TextField
                fullWidth
                label="Insert url"
                name="url"
                value={formik.values.url}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </Box>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formik.values.active}
                  name="active"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              }
              label="Continuous Crawl Active"
            />
            <Box mt={2}>
              <Button
                variant="contained"
                onClick={onClose}
                style={{ marginRight: 20 }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => formik.submitForm()}
              >
                Create
              </Button>
            </Box>
          </form>
        </>
      </div>
    </Modal>
  );
};
